module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAOCAYAAADwikbvAAAACXBIWXMAAAsTAAALEwEAmpwYAAABBklEQVQokZ3SsStFYRjH8c89uptBWRjOcN+VlYw2pVBundVKMpisUv4A8j+oN0RXRouBbBaD4ZTelFKymAwMDkkH9/qN7+/5Pr+e53n5h/Ki7IPGP8BZHGK0JzgvyhFcoB/DWQ/gIDoVuJ5iuO8KzouyiT20sI8NyPKiHKjM37SFSVxhIcXwChlu0PnYYE3qIpbwgLkUw/OHl+EOU9isASexjRe0Uwy3X/0MbTxhLS/K+S9gq5qzieUUw9n35o2qcBrHeMY4Es4xip0Uw0rdSBmkGE6w7v0MB9itwFOs1oGfyVV6A0eYqZ5KjKUYHv+EqwYDuMQQJlIM1z+BtcqLspEXZVef5w1QTEp09GpgdQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/gou.png
// module id = bv3p
// module chunks = 30